/*
 * Direita para contornar problema de utilização dos tooltips Bootstrap em conjunto com o Angular.
 * https://stackoverflow.com/questions/20666900/using-bootstrap-tooltip-with-angularjs
 */
angular.module("avlib").directive('avTooltip', function(){
	return {
		restrict: 'A',

		link: function(scope, element, attrs){
			var tooltipText = attrs.avTooltip;

			// Append to body é importante para evitar que os tooltips fiquem cortados dentro de DIVs
			// Trigger in hover é importante para que o tooltip não seja ativado quando o elemento ganha foco
			element.tooltip({container: 'body', trigger: 'hover'});
			
			// Nos tooltips estáticos, atribuímos neste momento o seu texto
            // Importante fazer esse ajuste após o append to body. Se não o append não funciona
			element.attr('data-original-title', tooltipText).tooltip('fixTitle');

			// Mecanismo de acionamento e fechamento do tooltip:
			element.hover(function(){
				var tooltipModel = attrs.avTooltipModel ? scope.$eval(attrs.avTooltipModel) : null;
				// A existência de um modelo indica um tooltip dinâmico. Avaliamos o texto para exibição
				if (tooltipModel){
					// Ajustando o conteúdo do tooltip para 
					element.attr('data-original-title', tooltipModel).tooltip('fixTitle');
				}
				// on mouseenter
				element.tooltip('show');
			}, function(){
				// on mouseleave
				element.tooltip('hide');
			});
		}
	};
});